/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attr_Flowering_TimeInputs */

const en_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flowering time`)
};

const th_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระยะเวลาออกดอก`)
};

const ja_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開花期間`)
};

const fr_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de floraison`)
};

const es_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de floración`)
};

const ru_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время цветения`)
};

const zh_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开花时间`)
};

const vi_attr_flowering_time = /** @type {(inputs: Attr_Flowering_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian ra hoa`)
};

/**
* | output |
* | --- |
* | "Flowering time" |
*
* @param {Attr_Flowering_TimeInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const attr_flowering_time = /** @type {((inputs?: Attr_Flowering_TimeInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attr_Flowering_TimeInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_attr_flowering_time(inputs)
	if (locale === "ja") return ja_attr_flowering_time(inputs)
	if (locale === "fr") return fr_attr_flowering_time(inputs)
	if (locale === "es") return es_attr_flowering_time(inputs)
	if (locale === "ru") return ru_attr_flowering_time(inputs)
	if (locale === "zh") return zh_attr_flowering_time(inputs)
	if (locale === "vi") return vi_attr_flowering_time(inputs)
	return en_attr_flowering_time(inputs)
});